<template>
    
    <div class="login-container">
        <img class="leq-logo" src="logo-leq-horiz.bmp" 
        alt="Logo Leblon Equities">
        <div class="login">
            <div class="login-card">
                <div class="login-header">
                    <h1 class="header">Criar uma nova conta</h1>
                </div>
                
                <div class="login-container">
                    <el-input v-model="email" placeholder="Email" @blur="checkEmail"></el-input><br>
                </div>
                
                <div class="login-container">
                    <el-input v-model="password" placeholder="Password" type="password"></el-input><br>
                </div>
                
                <el-alert v-show="visible" :title="errorMessage" type="error" @close="changeVisible" show-icon>
                </el-alert>
                
                <div class="login-container">
                    <el-button class="connect" type="primary" @click="signUp" round>Criar conta</el-button>
                </div>
                
                <div class="login-footer">
                    <p class="footer">Já possui uma conta?<br> Acesse a tela de <router-link to="/login">login</router-link>.</p>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import firebase from 'firebase/app'
    
    export default {
        name: 'signUp',
        data() {
            return {
                email: '',
                password: '',
                errorMessage: '',
                descriptionError: '',
                isToCreateAccount: false,
                visible: false,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                errorCode: {
                    "auth/invalid-email": "E-mail fora do formato padrão.",
                    "auth/email-already-in-use": "Já existe uma conta com esse endereço de e-mail",
                    "auth/operation-not-allowed": "Operação não permitida para esse e-mail. Entre em contato com o administrador.",
                    "auth/weak-password": "Sua senha deve ter pelo menos 6 caracteres."
                }
            }
        },
        methods: {
            async signUp() {
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
                    () => {
                        firebase.auth().currentUser.sendEmailVerification().then(
                            () => {
                                this.$alert('Foi enviado um e-mail de verificação de conta para o seu e-mail.','Verifique sua conta', {
                                    callback: this.$router.replace('login')
                                });
                            },
                            (err) => {
                                this.$alert(err.message)
                            }
                        );
                    },
                    (err) => {
                        this.errorMessage = this.errorCode[err.code]
                        this.visible = true
                    }
                );
                
            },
            changeVisible() {
                this.visible = false
            },
            checkEmail() {
                this.visible =  !this.reg.test(this.email) && (this.email != "");
                this.errorMessage = "E-mail fora do formato padrão."
            },
            handleVerifyEmail() {
                
            }
        }
    }
</script>


<style scoped>
    .leq-logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding: 70px 0;
    }
    .login {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin: 0 auto;
    }
    .login-card {
        width: 100%;
        text-align: center;
        justify-content: center;
    }
    .login-header {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .header {
        align-items: center;
        justify-content: center;
    }
    .login-container {
        margin-bottom: 15px;
    }
    .connect {
        margin-top: 10px;
        width: 100%;
        font-size: 12.5px;
        line-height: 0.5;
        cursor: pointer;
    }
    span {
        display: block;
        margin-top: 20px;
        font-size: 11px;
    }
    h1 {
        font-family: Merriweather, serif;
        font-weight: 500;
        line-height: 1.35;
        color: #505050;
    }
    .login-footer {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .footer {
        align-items: center;
        justify-content: center;
    }
    .login-footer p {
        font-family: Merriweather, serif;
        font-weight: 30;
        line-height: 1.35;
        color: #505050;
    }
</style>